import React, { Component } from 'react';
import { Dialog } from 'primereact/dialog';
import Editor from '@monaco-editor/react';

class TransactionFailureModalComponent extends Component<Props> {
  public render() {
    const { visible, failures, onClose } = this.props;
    return (
      <Dialog className={'w-5/6 h-5/6'} visible={visible} onHide={onClose} dismissableMask closable={false} closeOnEscape>
        <div className={'w-full h-full overflow-y-scroll'}>
          <div className={'flex justify-center items-center h-full'}>
            <Editor options={{ readOnly: true }} language='json' value={JSON.stringify(failures, null, 2)} />
          </div>
        </div>
      </Dialog>
    );
  }
}

interface Props {
  visible: boolean;
  onClose: () => void;
  failures: any[];
}

export default TransactionFailureModalComponent;
